import { Link } from 'react-router-dom'
import turn from '../../../assets/form.webp'


const Form = ():JSX.Element => {
      return (
        <div className='flex flex-col bg-white w-4/5 sm:h-auto h-auto rounded-t-xl mb-4'>
             
              <div>
              <img className='w-full h-60 rounded-t-xl' src={turn} alt='asd' />
              </div>
              
              <div className='ml-4 mt-2 mb-2'>
                <h1 className='sm:text-[28px] text-[20px] mb-1 font-roboto font-medium'>LLENAR FORMULARIOS</h1>
                <h4 className='font-roboto text-[13px] sm:text-[20px] '>{`Completa los formularios correspondientes (Consentimiento y DDJJ)`}</h4>
              </div>
             
            <Link to='/formularios'>
             <button className='bg-background_home rounded-xl text-white p-[4px] px-4 ml-4 mt-10 '>FORMULARIOS</button>
            </Link> 

        </div>
      )
}


export default Form